/**
 * Author: Romain Hapi Sr.
 * Version: 1.0
 * Date: 2026-06-25
 * Project: Prenim Digital
 * Copyright: Prenim UK
 */
/**
 * `cn` fusionne des listes de classes Tailwind.
 *
 * `clsx` assemble et filtre les valeurs conditionnelles ; `twMerge` resout
 * ensuite les conflits entre utilitaires de meme famille, en gardant le
 * dernier. Sans lui, `px-4` suivi de `px-6` laisserait les deux dans l'attribut
 * et le resultat dependrait de l'ordre dans la feuille de style, pas de l'ordre
 * d'appel.
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
